"use statics";

export default {
  APP_RENDER: "APP_RENDER",
  APP_INIT: "APP_INIT",
  APP_INIT_FAILED: "APP_INIT_FAILED",

  APP_LOADING_START: "APP_LOADING_START",
  APP_LOADING_STOP: "APP_LOADING_STOP",
  APP_ERROR: "APP_ERROR",
  APP_ERROR_CLOSE: "APP_ERROR_CLOSE",
  APP_INFO: "APP_INFO",
  APP_INFO_CLOSE: "APP_INFO_CLOSE",

  APP_CHANGE_SETTINGS_SUCCESS: "APP_CHANGE_SETTINGS_SUCCESS",

  APP_CONFIRM: "APP_CONFIRM",
  APP_REJECT: "APP_REJECT",
  APP_PAY: "APP_PAY",

  AUTH_SIGN_IN: "AUTH_SIGN_IN",
  AUTH_SIGN_IN2: "AUTH_SIGN_IN2",
  AUTH_SIGN_IN3: "AUTH_SIGN_IN3",
  AUTH_SIGN_OUT: "AUTH_SIGN_OUT",
  AUTH_SIGN_UP: "AUTH_SIGN_UP",
  AUTH_SIGN_UP2: "AUTH_SIGN_UP2",
  AUTH_SIGN_UP3: "AUTH_SIGN_UP3",
  AUTH_CHANGE_PASSWORD: "AUTH_CHANGE_PASSWORD",
  AUTH_RESET_PASSWORD: "AUTH_RESET_PASSWORD",

  PROFILE_AUTHENTICATOR_EDIT_SUCCESS: "PROFILE_AUTHENTICATOR_EDIT_SUCCESS",
  PROFILE_AUTHENTICATOR_ENABLE_SUCCESS: "PROFILE_AUTHENTICATOR_ENABLE_SUCCESS",
  PROFILE_AUTHENTICATOR_ENABLE_FAILED: "PROFILE_AUTHENTICATOR_ENABLE_FAILED",
  PROFILE_AUTHENTICATOR_DISABLE_SUCCESS: "PROFILE_AUTHENTICATOR_DISABLE_SUCCESS",
  PROFILE_AUTHENTICATOR_DISABLE_FAILED: "PROFILE_AUTHENTICATOR_DISABLE_FAILED",

  APP_BUY_SUCCESS: "APP_BUY_SUCCESS",
  APP_BUY_ERROR: "APP_BUY_ERROR",
  APP_BUY_CLEAR: "APP_BUY_CLEAR",

  APP_AUTHENTICATORS_SUCCESS: "APP_AUTHENTICATORS_SUCCESS",
  APP_AUTHENTICATOR: "APP_AUTHENTICATOR",
  APP_AUTHENTICATOR_CONFIRM: "APP_AUTHENTICATOR_CONFIRM",
  APP_REFLINK: "APP_REFLINK",
  APP_GAS_PRICE_SUCCESS: "APP_GAS_PRICE_SUCCESS",
  APP_EXCHANGE_RATES_SUCCESS: "APP_EXCHANGE_RATES_SUCCESS",
  APP_BALANCE_SUCCESS: "APP_BALANCE_SUCCESS",
  APP_HISTORY_SUCCESS: "APP_HISTORY_SUCCESS",
  APP_TRANSACTION_SUCCESS: "APP_TRANSACTION_SUCCESS",
  APP_ASSETS_SUCCESS: "APP_ASSETS_SUCCESS",
  APP_ASSET_ADD: "APP_ASSET_ADD",
  APP_ASSET_DELETE: "APP_ASSET_DELETE",
  APP_ADDRESSBOOK_SUCCESS: "APP_ADDRESSBOOK_SUCCESS",
  APP_ADDRESSBOOK_ADD: "APP_ADDRESSBOOK_ADD",
  APP_ADDRESSBOOK_EDIT: "APP_ADDRESSBOOK_EDIT",
  APP_ADDRESSBOOK_DELETE: "APP_ADDRESSBOOK_DELETE",

  APP_CONNECT: "APP_CONNECT",
  APP_APPLICATIONS: "APP_APPLICATIONS",
  APP_APPLICATION: "APP_APPLICATION",
  APP_APPLICATION_ADD: "APP_APPLICATION_ADD",
  APP_APPLICATION_EDIT: "APP_APPLICATION_EDIT",
  APP_CONTRACT: "APP_CONTRACT",
  APP_CONTRACT_ADD: "APP_CONTRACT_ADD",
  APP_CONTRACT_DELETE: "APP_CONTRACT_DELETE",

  LIST: "LIST",
  HIDDENLIST: "HIDDENLIST",
  HIDDENITEM: "HIDDENITEM",
};
